interface Props {
  color?: string
  width?: number
  height?: number
}

export const InstagramIcon = ({ color = '#6F6F6F', width = 22, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.2188 0C18.975 7.88526e-05 21.2097 2.23499 21.21 4.99121V16.2188C21.2099 18.9751 18.9751 21.2099 16.2188 21.21H4.99121C2.23499 21.2097 7.88507e-05 18.975 0 16.2188V4.99121C0.000230874 2.23508 2.23508 0.000230875 4.99121 0H16.2188ZM4.99121 1C2.78736 1.00023 1.00023 2.78736 1 4.99121V16.2188C1.00008 18.4227 2.78727 20.2097 4.99121 20.21H16.2188C18.4228 20.2099 20.2099 18.4228 20.21 16.2188V4.99121C20.2097 2.78727 18.4227 1.00008 16.2188 1H4.99121ZM10.6055 5.61426C13.3618 5.61439 15.5967 7.84907 15.5967 10.6055C15.5965 13.3618 13.3618 15.5965 10.6055 15.5967C7.84907 15.5967 5.61439 13.3618 5.61426 10.6055C5.61426 7.84899 7.84899 5.61426 10.6055 5.61426ZM10.6055 6.61426C8.40127 6.61426 6.61426 8.40127 6.61426 10.6055C6.61439 12.8096 8.40135 14.5967 10.6055 14.5967C12.8095 14.5965 14.5965 12.8095 14.5967 10.6055C14.5967 8.40135 12.8096 6.61439 10.6055 6.61426ZM16.7803 3.30762C17.4002 3.30762 17.9031 3.80976 17.9033 4.42969C17.9033 5.04979 17.4004 5.55273 16.7803 5.55273C16.1602 5.55266 15.6572 5.04974 15.6572 4.42969C15.6574 3.80981 16.1604 3.30769 16.7803 3.30762Z"
        fill={color}
      />
    </svg>
  )
}
